import { type CSSObject, inputBaseClasses, outlinedInputClasses } from '@mui/material'
import { type ComponentsOverrides, type Theme } from '@mui/material/styles'
import { rem } from 'polished'

import { typographyOverrides } from '@Material/typography'
import { RADIUS_1 } from '@Styles/constants/radius'

export const overridesOutlinedInput = (theme: Theme): ComponentsOverrides['MuiOutlinedInput'] => ({
  root: {
    borderRadius: RADIUS_1,
    '@supports (-webkit-appearance: none)': {
      [`.${outlinedInputClasses.notchedOutline} legend`]: {
        transition: 'none', // We use this for safari only: https://github.com/mui/material-ui/issues/46891#issuecomment-3323984702
      },
    },
    [`&.${inputBaseClasses.multiline} > .${inputBaseClasses.input}`]: {
      padding: 0,
    },
    [`&.${inputBaseClasses.adornedStart} > .${inputBaseClasses.input}`]: {
      padding: `${rem(16.5)} 0`,
    },
    [`&.${inputBaseClasses.adornedEnd} > .${inputBaseClasses.input}`]: {
      paddingRight: 0,
    },
  },
  input: {
    ...(typographyOverrides(theme)?.body2 as CSSObject),
    height: rem(23),
    lineHeight: rem(23), // according to figma guidelines
    padding: `${rem(16.5)} ${theme.spacing(2)}`, // according to figma guidelines

    [`&.${outlinedInputClasses.disabled}`]: {
      backgroundColor: theme.customPalette.background.default,
      borderColor: theme.customPalette.background.default,
    },
  },
  multiline: {
    padding: `${rem(16.5)} ${theme.spacing(2)}`, // according to figma guidelines
  },
})
